import React from "react";
import "./SisenseHomePageWidget.css";

export default function SisenseHomePageWidget(props) {
  const { iframeUrl, iframeId } = props;

  return (
    <iframe
      src={iframeUrl}
      id={iframeId}
      className="sisense-homepage-widget"
    ></iframe>
  );
}
